import { render, staticRenderFns } from "./PolicyType4.vue?vue&type=template&id=c4e5d60c&scoped=true"
import script from "./PolicyType4.vue?vue&type=script&lang=js"
export * from "./PolicyType4.vue?vue&type=script&lang=js"
import style0 from "./PolicyType4.vue?vue&type=style&index=0&id=c4e5d60c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e5d60c",
  null
  
)

export default component.exports